/* A Prima Vista · Tikual 2026-10
 * 1. Guía de tallas: convierte el texto "Medidas" de la descripción en tablas por prenda.
 * 2. Barra fija de compra en móvil.
 */
(function () {
  'use strict';

  var SIZE_RE = /\b(xx?s|xx?l|small|medium|large|m\s*[\/-]\s*l|l\s*[\/-]\s*xl|s\s*[\/-]\s*m|[sml])\s+(\d{2,3}(?:\s*[-–]\s*\d{2,3})?)\s*(?:cm)?/gi;
  var SIZE_LABEL = { small: 'S', medium: 'M', large: 'L' };

  function clean(t) {
    return t.replace(/ /g, ' ').replace(/\s+/g, ' ').trim();
  }
  function sizeLabel(s) {
    var k = s.toLowerCase().replace(/\s+/g, '');
    return SIZE_LABEL[k] || k.toUpperCase();
  }
  function cap(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  // Devuelve { note, groups: [{ title, note, sizes: [], rows: [{ label, values: {} }] }] } o null
  function parseMeasures(lines) {
    var result = { note: '', groups: [] };
    var group = null;
    lines.forEach(function (raw) {
      var line = clean(raw);
      if (!line) return;
      var head = line.match(/^medidas\s*:?\s*(.*)$/i);
      if (head) {
        var n = head[1].replace(/[()]/g, '').trim();
        if (n) result.note = cap(n);
        return;
      }
      SIZE_RE.lastIndex = 0;
      var first = SIZE_RE.exec(line);
      if (!first) {
        // Encabezado de prenda: "polo:", "pantalón palazzo: estira 4 cm"
        var m = line.match(/^([^:]{2,40}):\s*(.*)$/);
        if (m) {
          group = { title: cap(m[1].trim()), note: cap(m[2].trim()), sizes: [], rows: [] };
          result.groups.push(group);
        }
        return;
      }
      var label = clean(line.slice(0, first.index)).replace(/[:,]$/, '');
      if (!label) return;
      if (!group) {
        group = { title: '', note: '', sizes: [], rows: [] };
        result.groups.push(group);
      }
      var row = { label: cap(label), values: {} };
      SIZE_RE.lastIndex = 0;
      var mm;
      while ((mm = SIZE_RE.exec(line))) {
        var s = sizeLabel(mm[1]);
        row.values[s] = mm[2].replace(/\s+/g, '');
        if (group.sizes.indexOf(s) === -1) group.sizes.push(s);
      }
      group.rows.push(row);
    });
    result.groups = result.groups.filter(function (g) { return g.rows.length; });
    return result.groups.length ? result : null;
  }

  function linesFromHTML(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html.replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>/gi, '\n');
    return tmp.textContent.split('\n');
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function renderTables(data) {
    var html = '<div class="apv-sg">';
    html += '<p class="apv-sg__tip">Medidas de la prenda en centímetros.' + (data.note ? ' ' + esc(data.note) + '.' : '') + '</p>';
    data.groups.forEach(function (g) {
      if (g.title) html += '<h4 class="apv-sg__title">' + esc(g.title) + (g.note ? ' <span>' + esc(g.note) + '</span>' : '') + '</h4>';
      html += '<table class="apv-sg__table"><thead><tr><th>Medida</th>';
      g.sizes.forEach(function (s) { html += '<th>' + esc(s) + '</th>'; });
      html += '</tr></thead><tbody>';
      g.rows.forEach(function (r) {
        html += '<tr><td>' + esc(r.label) + '</td>';
        g.sizes.forEach(function (s) { html += '<td>' + esc(r.values[s] || '–') + '</td>'; });
        html += '</tr>';
      });
      html += '</tbody></table>';
    });
    html += '</div>';
    return html;
  }

  function initSizeGuides(scope) {
    (scope || document).querySelectorAll('[data-apv-sizeguide]:not([data-apv-done])').forEach(function (el) {
      el.setAttribute('data-apv-done', '');
      var src = el.querySelector('[data-apv-sizeguide-source]');
      if (!src) return;
      var data = parseMeasures(linesFromHTML(src.innerHTML));
      if (data) src.outerHTML = renderTables(data);
    });
  }

  // Barra fija de compra (móvil)
  function initStickyATC() {
    var bar = document.querySelector('[data-apv-sticky]');
    if (!bar) return;
    // Fuera de contenedores con animación de entrada: en iPhone un position:fixed dentro de un
    // elemento con transform/opacidad animada queda mal colocado o invisible.
    document.body.appendChild(bar);
    var form = document.querySelector('.product-form .product-purchase-form');
    var mainBtn = form && form.querySelector('button[type="submit"]');
    if (!mainBtn) { bar.remove(); return; }
    var variantEl = bar.querySelector('[data-apv-sticky-variant]');
    var priceEl = bar.querySelector('[data-apv-sticky-price]');
    var stickyBtn = bar.querySelector('button');

    function sync() {
      var sel = form.querySelector('select[name="id"], input[name="id"]');
      var opt = sel && sel.tagName === 'SELECT' ? sel.options[sel.selectedIndex] : null;
      if (opt && variantEl) variantEl.textContent = opt.textContent.split(' - ')[0].trim();
      var price = document.querySelector('.product-form .product-price .current-price, .product-form .price-area .current-price');
      if (price && priceEl) priceEl.textContent = clean(price.textContent);
      stickyBtn.disabled = mainBtn.disabled;
      stickyBtn.textContent = clean(mainBtn.textContent);
    }

    stickyBtn.addEventListener('click', function () { mainBtn.click(); });
    form.addEventListener('change', function () { setTimeout(sync, 60); });
    new MutationObserver(function () { sync(); }).observe(mainBtn, { attributes: true, childList: true, subtree: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting; // visible siempre que el botón principal no esté en pantalla
        bar.classList.toggle('is-visible', show);
        document.documentElement.classList.toggle('apv-sticky-on', show);
      }).observe(mainBtn);
    }
    sync();
  }

  // Aviso visible cuando Shopify rechaza "Agregar al carrito" (sin stock suficiente, etc.).
  // Sustituye el popup del tema, que aparece junto al botón principal y queda fuera de pantalla
  // si el cliente usó la barra fija o hizo scroll.
  function friendlyCartError(msg) {
    var m = (msg || '').toLowerCase();
    if (/cantidad m[aá]xima|maximum quantity|all \d+ |todas? las? \d+|todos los \d+|ya est[aá]n en tu carrito|only add/.test(m)) {
      return 'Ya tienes en el carrito todas las unidades disponibles de esta talla.';
    }
    if (/agotad|sold out|no est[aá] disponible|not available/.test(m)) {
      return 'Esta talla está agotada. Prueba con otra talla o escríbenos por WhatsApp.';
    }
    return msg || 'No pudimos agregar el producto. Inténtalo de nuevo.';
  }

  function showToast(text) {
    var old = document.querySelector('.apv-toast');
    if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'apv-toast';
    el.setAttribute('role', 'alert');
    el.innerHTML = '<span></span><a href="/cart">Ver carrito</a>';
    el.querySelector('span').textContent = text;
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-visible'); });
    setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.remove(); }, 300);
    }, 5000);
  }

  // Si ya tiene en el carrito todas las unidades, abre igualmente el carrito lateral con esa prenda
  // para que el cliente llegue a "Finalizar compra".
  function openDrawerForVariant($origin) {
    var $ = window.jQuery;
    var form = $origin && $origin.closest ? $origin.closest('form')[0] : null;
    var idEl = form && form.querySelector('[name="id"]');
    if (!$ || !idEl || !window.theme || !window.theme.addedToCartHandler) return;
    var variantId = Number(idEl.value);
    Promise.all([
      fetch('/cart.js').then(function (r) { return r.json(); }),
      fetch('/?sections=cart-drawer').then(function (r) { return r.json(); })
    ]).then(function (res) {
      var item = (res[0].items || []).filter(function (i) { return i.variant_id === variantId; })[0];
      if (!item || !res[1]['cart-drawer']) return;
      window.theme.addedToCartHandler.call($(form), { key: item.key, sections: { 'cart-drawer': res[1]['cart-drawer'] } });
    }).catch(function () {});
  }

  function initCartErrors() {
    if (window.theme) {
      window.theme.showQuickPopup = function (message, $origin) {
        var text = friendlyCartError(message);
        showToast(text);
        if (/todas las unidades disponibles/.test(text)) openDrawerForVariant($origin);
      };
    }
  }

  // Carrito lateral: el tema lo cerraba con cualquier scroll. En móvil, la barra del navegador
  // o la inercia del dedo generan scroll y el carrito se cerraba sin llegar a verse.
  // Ahora se cierra solo con "Seguir comprando", la X o tocando fuera.
  function initCartDrawer() {
    var $ = window.jQuery;
    function unbindScrollClose() { if ($) $(window).off('scroll.ajaxAddScroll'); }
    unbindScrollClose();
    document.documentElement.addEventListener('theme:cartchanged', function () { setTimeout(unbindScrollClose, 0); });
    function close() { if (window.theme && window.theme.removeAddedCartDrawer) window.theme.removeAddedCartDrawer(); }
    document.addEventListener('click', function (e) {
      var overlay = document.querySelector('.cart-summary-overlay:not(.cart-summary-overlay--off-screen)');
      if (!overlay) return;
      if (e.target.closest('.apv-drawer-close')) { e.preventDefault(); close(); return; }
      if (!overlay.contains(e.target) && !e.target.closest('.product-form, [data-apv-sticky], .apv-toast')) close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  // Página /cart en móvil: barra fija con el total y "Finalizar pedido" que pulsa el botón real del formulario
  function initCartPageBar() {
    if (!document.body.classList.contains('template-cart')) return;
    var realBtn = document.querySelector('#update-cart, form[action*="/cart"] button[name="checkout"]');
    if (!realBtn) return;
    var bar = document.createElement('div');
    bar.className = 'apv-cart-bar';
    bar.innerHTML = '<span class="apv-cart-bar__total">Total<strong data-apv-total></strong></span>' +
      '<button type="button" class="button"></button>';
    bar.querySelector('button').textContent = clean(realBtn.textContent) || 'Finalizar pedido';
    bar.querySelector('button').addEventListener('click', function () {
      var btn = document.querySelector('#update-cart, #cartform button[name="checkout"]') || realBtn;
      btn.click();
    });
    document.body.appendChild(bar);
    var totalEl = bar.querySelector('[data-apv-total]');
    function sync() {
      var btn = document.querySelector('#update-cart, #cartform button[name="checkout"]');
      bar.hidden = !btn;
      document.documentElement.classList.toggle('apv-cartbar-on', !!btn);
      if (btn) realBtn = btn;
      var sub = document.querySelector('.checkout-subtotal-container .subtotal .theme-money');
      totalEl.textContent = sub ? clean(sub.textContent) : '';
      totalEl.parentElement.style.display = sub ? '' : 'none';
    }
    sync();
    var section = document.querySelector('[data-section-type="cart-template"]');
    if (section) new MutationObserver(function () { sync(); }).observe(section, { childList: true, subtree: true, characterData: true });
  }

  // Página /cart: no permitir subir cantidades por encima del stock y avisar si Shopify rechaza el cambio.
  function initCartQuantities() {
    if (!document.body.classList.contains('template-cart')) return;
    var MAX_MSG = 'Ya tienes en el carrito todas las unidades disponibles de esta talla.';
    document.addEventListener('click', function (e) {
      var up = e.target.closest('.quantity-up');
      if (!up) return;
      var input = up.closest('.quantity') && up.closest('.quantity').querySelector('input');
      var max = input && Number(input.getAttribute('data-max'));
      if (up.classList.contains('unusable') || (max && Number(input.value) >= max)) {
        e.preventDefault();
        e.stopPropagation();
        showToast(MAX_MSG);
      }
    }, true);
    document.addEventListener('change', function (e) {
      var input = e.target.closest && e.target.closest('.cart-item__quantity-input');
      if (!input) return;
      var max = Number(input.getAttribute('data-max'));
      if (max && Number(input.value) > max) {
        input.value = max;
        showToast(MAX_MSG);
      }
    }, true);
    var $ = window.jQuery;
    if ($) {
      $(document).ajaxError(function (evt, xhr, settings) {
        if (!settings || !/\/cart\/change/.test(settings.url || '') || xhr.statusText === 'abort') return;
        var msg = '';
        try { msg = JSON.parse(xhr.responseText).description; } catch (err) {}
        showToast(/disponibilidad|available|stock/i.test(msg || '') ? MAX_MSG : friendlyCartError(msg));
        // Vuelve a pintar el carrito con las cantidades reales
        document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true }));
      });
    }
  }

  // Barra de anuncios: si el móvil tiene "Reducir movimiento", rota los mensajes con un fundido
  function initMarquee() {
    var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    document.querySelectorAll('.apv-marquee').forEach(function (bar) {
      var items = [];
      var group = bar.querySelector('.apv-marquee__group');
      if (!group) return;
      var seen = {};
      group.querySelectorAll('.apv-marquee__item').forEach(function (it) {
        var key = it.textContent.trim();
        if (!seen[key]) { seen[key] = true; items.push(it.innerHTML); }
      });
      var fade = document.createElement('div');
      fade.className = 'apv-marquee__fade';
      fade.setAttribute('aria-hidden', 'true');
      bar.appendChild(fade);
      var i = 0, timer = null;
      function show() { fade.innerHTML = items[i % items.length]; }
      function start() {
        if (timer) return;
        bar.classList.add('apv-marquee--fade');
        show();
        timer = setInterval(function () {
          fade.classList.add('is-out');
          setTimeout(function () { i++; show(); fade.classList.remove('is-out'); }, 400);
        }, 4000);
      }
      function stop() { clearInterval(timer); timer = null; bar.classList.remove('apv-marquee--fade'); }
      function apply() { if (mq && mq.matches) start(); else stop(); }
      apply();
      if (mq && mq.addEventListener) mq.addEventListener('change', apply);
      else if (mq && mq.addListener) mq.addListener(apply);
    });
  }

  function init() {
    initMarquee();
    initCartQuantities();
    initSizeGuides();
    initStickyATC();
    initCartErrors();
    initCartDrawer();
    initCartPageBar();
  }

  if (typeof module !== 'undefined') {
    module.exports = { parseMeasures: parseMeasures };
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  if (typeof document !== 'undefined') {
    document.addEventListener('shopify:section:load', function (e) { initSizeGuides(e.target); });
  }
})();
